<template>
  <div>
    <div
      class="breadcrumb-area pos-relative w-100"
      v-if="dataPermission.includes('CNPS_DEVICE_ORDER_BALANCE_VIEW')"
    >
      <h1>Chi tiết phiếu điều chỉnh số lượng vật tư</h1>
      <div class="btn-group float-right">
        <button
          v-if="canApprove(detail.status, 'CNPS_DEVICE_ORDER_BALANCE_APPROVE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="approveItem(detail)"
        >
          Duyệt
        </button>
        <button
          v-if="canReject(detail.status, 'CNPS_DEVICE_ORDER_BALANCE_APPROVE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="rejectItem(detail)"
        >
          Từ chối
        </button>
        <button
          v-if="canUpdate(detail.status, 'CNPS_DEVICE_ORDER_BALANCE_UPDATE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="edit(detail.id)"
        >
          Sửa
        </button>
        <button
          v-if="canCancel(detail.status, 'CNPS_DEVICE_ORDER_BALANCE_CHANGE_STATUS')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="cancelItem(detail)"
        >
          Hủy
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="form-detail">
                  <h1>Thông tin phiếu điều chỉnh số lượng vật tư</h1>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Tên kho<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.inventoryNameExport }}</p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Mã phiếu<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.billNumber }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Người tạo<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.userCreator ? detail.userCreator.name : '' }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Ngày tạo<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Ghi chú<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{
                          detail.noteImport
                            ? detail.noteImport
                            : detail.noteExport
                              ? detail.noteExport
                              : detail.description
                        }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Trạng thái<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        <span class="badge" :class="[detail.status ? detail.status : '']">
                          {{ detail.status | transformData(dataStatus) }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row" v-if="detail.status === 'APPROVED'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Người duyệt<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.personApprove ? detail.personApprove.name : '' }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row" v-if="detail.status === 'APPROVED'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Ngày duyệt<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-2 col-form-label"
                      >Người từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.personReject ? detail.personReject.name : '' }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-2 col-form-label"
                      >Ngày từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.timeReject | formatDate('HH:mm, DD/MM/YYYY') }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-2 col-form-label"
                      >Lý do từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.reasonReject }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-detail">
                  <div class="d-flex justify-content-between">
                    <h1>Danh sách vật tư cần điều chỉnh</h1>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table table-hover table-bordered"
                      style="max-height: 400px; overflow-y: auto"
                    >
                      <thead class="thead-light">
                        <tr>
                          <th scope="col"><b>Mã vật tư</b></th>
                          <th scope="col"><b>Tên vật tư</b></th>
                          <th scope="col"><b>Thời điểm ghi nhận</b></th>
                          <th scope="col"><b>SL trên hệ thống</b></th>
                          <th scope="col"><b>SL thực tế</b></th>
                          <th scope="col"><b>Điều chỉnh</b></th>
                          <th scope="col"><b>Ghi chú</b></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="table-row" v-for="(item, index) in listMaterial" :key="index">
                          <td class="text-center">{{ item.abbreviation }}</td>
                          <td class="text-center">
                            <span> {{ item.categoryName }}</span>
                          </td>
                          <td class="text-center">
                            <span>{{ item.dateConfirm | formatDate('HH:mm, DD/MM/YYYY') }}</span>
                          </td>
                          <td class="text-center">{{ item.beforeChangeQuantity }}</td>
                          <td class="text-center">{{ item.afterChangeQuantity }}</td>
                          <td class="text-center">
                            {{
                              item.afterChangeQuantity - item.beforeChangeQuantity < 0
                                ? 'Giảm:'
                                : 'Tăng:'
                            }}
                            {{ Math.abs(item.afterChangeQuantity - item.beforeChangeQuantity) }}
                          </td>
                          <td class="text-center">{{ item.note }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div>
                <span
                  >Tổng thay đổi: Tăng: {{ detail.quantityImport }} Giảm:
                  {{ detail.quantityExport }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'

  export default {
    name: 'detail-quantity-material',
    data() {
      return {
        Config,
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        id: this.$route.params.id,
        detail: {},
        listMaterial: [],
        dataStatus: [{ id: '0', text: 'Tất cả' }, ...Config.statusImportWarehouse],
      }
    },
    mixins: [mxItemAction],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    created() {
      this.fetchData()
    },

    methods: {
      backToList() {
        this.$router.push('/quantity-material')
      },
      async fetchData() {
        try {
          const id = this.$route.params.id
          this.showLoading = true
          const data = await DeviceService.detailQuantityMaterial({ id })
          if (data.success || data.code === 1000) {
            this.detail = data.data
            this.listMaterial = data.data.devices.map(item => {
              return {
                categoryId: item.categoryId,
                abbreviation: item.abbreviation,
                categoryName: item.categoryName,
                dateConfirm: item.dateConfirm,
                beforeChangeQuantity: item.beforeChangeQuantity,
                note: item.noteImport ? item.noteImport : item.noteExport,
                afterChangeQuantity: item.afterChangeQuantity,
                changeQuantity: item.changeQuantity,
              }
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
